import { useEffect, useRef, useState } from "react";
import { useTheme } from "../../../contexts/ThemeContext";

const STATS = [
  { value: "15–22%", label: "Avg. fees most flippers miss", icon: "ri-eye-off-line" },
  { value: "10+", label: "Selling platforms supported", icon: "ri-store-2-line" },
  { value: "2 min", label: "Time to calculate any flip", icon: "ri-flashlight-line" },
  { value: "Free", label: "Early access — no credit card", icon: "ri-gift-line" },
];

export default function StatsSection() {
  const { isDark } = useTheme();
  const sectionRef = useRef<HTMLDivElement>(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const el = sectionRef.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setInView(true);
          obs.unobserve(el);
        }
      },
      { threshold: 0.15 }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, []);

  return (
    <section
      className={`hidden lg:block py-20 px-8 lg:px-16 border-y transition-colors duration-300 ${
        isDark ? "bg-[#050505] border-white/5" : "bg-white border-black/5"
      }`}
    >
      <div className="max-w-7xl mx-auto">
        {/* Stats grid */}
        <div
          ref={sectionRef}
          className={`grid grid-cols-2 lg:grid-cols-4 gap-px ${
            isDark ? "bg-white/5" : "bg-black/5"
          }`}
        >
          {STATS.map((stat, i) => (
            <div
              key={stat.label}
              className={`px-8 py-10 text-center group cursor-default reveal-up${inView ? " in-view" : ""} ${
                isDark ? "bg-[#050505]" : "bg-white"
              }`}
              style={{ transitionDelay: inView ? `${i * 100}ms` : "0ms" }}
            >
              <div className="w-10 h-10 flex items-center justify-center mx-auto mb-4">
                <i
                  className={`${stat.icon} text-xl transition-colors duration-300 ${
                    isDark
                      ? "text-[#555555] group-hover:text-[#666666]"
                      : "text-[#aaaaaa] group-hover:text-[#666666]"
                  }`}
                />
              </div>
              <p
                className={`font-syne font-bold text-3xl mb-2 ${
                  isDark ? "text-white" : "text-[#111111]"
                }`}
              >
                {stat.value}
              </p>
              <p
                className={`font-inter text-sm ${
                  isDark ? "text-[#666666]" : "text-[#777777]"
                }`}
              >
                {stat.label}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
